import {PROTOCOL_SLIDE_TYPES} from '@learningblocks/protocol-constants/lib/Utilities';

export function slideThreeRemoveDrop(state, payload) {
  return {
    ...state,
    protocolSection: removeInDesignSection(state.protocolSection, payload),
  };
}

function removeInDesignSection(protocolSection, payload) {
  function updateInNode(node) {
    if (node.nodeId === payload.nodeId) {
      node.droppedId = null;
    }
    return node;
  }

  function updateInGroup(group) {
    if (group.groupId === payload.groupId) {
      group.groupNodes = group.groupNodes.map(updateInNode);
    }
    return group;
  }

  function updateSlideThree(slide) {
    return {
      ...slide,
      slideTree: slide.slideTree.map(updateInGroup),
    };
  }

  function updateInSlide(slide) {
    if (slide.type === PROTOCOL_SLIDE_TYPES.THREE) {
      slide = updateSlideThree(slide);
    }
    return slide;
  }

  return {
    ...protocolSection,
    allSlides: protocolSection.allSlides.map(updateInSlide),
  };
}
